import styled from 'styled-components'

export const FooterContainer = styled.footer`
  overflow-x: hidden;
`

